<template>
  <nav class="sidenav">
    <el-menu
      :default-active="active"
      :unique-opened="true"
      :default-openeds="opened"
      :collapse="bodyWidth < 1280"
    >
      <div v-for="menu in menus">
        <div v-if="menu.children">
          <el-submenu :index="`${menu.id}`">
            <template slot="title">
              <i :class="`iconfont ${menu.icon}`"></i>
              <el-badge is-dot class="item px-badge" v-if="menu.hasNewPoint === true">
                <span class="menu-name">{{menu.name}}</span>
              </el-badge>
              <span v-else class="menu-name">{{menu.name}}</span>
            </template>
            <div v-for="child in menu.children"
                 v-if="(checkMenuAuthority(child))"
                 :class="child.className ? child.className : null">
              <el-menu-item
                :index="`${child.id}`"
                v-if="(child.path && child.path !== '/Member/MemberTransfer') || (child.path === '/Member/MemberTransfer' && !crmUpdateClose)"
                @click="jump(child, menu)"
              >
                <el-badge value="NEW" class="item px-badge" v-if="child.hasNewPoint">
                  {{child.name}}
                </el-badge>
                <span v-else>{{child.name}}</span>
              </el-menu-item>
              <a :href="ctx+getMenuPath(child.oldPath)" v-else-if="child.oldPath">
                <el-menu-item :index="child.id">{{child.name}}</el-menu-item>
              </a>
            </div>
          </el-submenu>
        </div>
        <div v-else>
          <router-link :to="menu.path" v-if="menu.path">
            <el-menu-item :index="`${menu.id}`">
              <i :class="`iconfont ${menu.icon}`"></i>
              <span slot="title" class="menu-name">{{menu.name}}</span>
            </el-menu-item>
          </router-link>
          <a :href="ctx+getMenuPath(menu.oldPath)" v-else>
            <el-menu-item :index="menu.id">
              <i :class="'iconfont '+menu.icon"></i>
              {{menu.name}}
            </el-menu-item>
          </a>
        </div>
      </div>
    </el-menu>
  </nav>
</template>

<script>
  import {mapState} from 'vuex';
  import menu from '@constants/menu';
  import getMenuPath from "@util/getMenuPath";
  import getRouterConf from '@util/getRouterConf';
  import ignoreMenus from '@constants/ignoreMenu';
  import isCRMUser from '@util/isCRMUser';

  export default {
    data () {
      return {
        menus: menu,
        ctx: isCRMUser() ? '/hq-web/indexnew#' : '/hq-web/index#',
        active: null,
        opened: [],
        permissionList: [],
        bodyWidth: document.body.clientWidth
      };
    },
    computed: {
      ...mapState(['crmUpdateClose'])
    },
    created () {
      let permissionList = localStorage.getItem('menuList');
      if (permissionList === null) {
        this.$axios.get('/hq-web/reportCenter/perm').then((res) => {
          const menus = res.data;
          localStorage.setItem('menu', JSON.stringify(menus));
          permissionList = menus.map((item) => {
            return item.id;
          });
          localStorage.setItem('menuList', JSON.stringify(permissionList));
          this.permissionList = permissionList;
        });
      } else {
        this.permissionList = JSON.parse(localStorage.getItem('menuList'));
      }
      this.checkBodyWidth();
      this.handleRouteChange();
    },
    watch: {
      '$route': function () {
        this.handleRouteChange();
      }
    },
    methods: {
      getMenuPath: getMenuPath,
      handleRouteChange () {
        if (this.$route.path !== '/Midware') {
          let checkPermission = true;
          ignoreMenus.forEach(ignoreMenu => {
            if (this.$route.path === ignoreMenu) {
              checkPermission = false;
            }
          });
          if (checkPermission) {
            const config = getRouterConf(this.$route.path);
            this.active = config[1].id.toString();
            this.opened = this.bodyWidth <= 1280 ? [] : [config[0].id.toString()];
          }
        }
      },
      checkMenuAuthority (item) {
        if (item.id === '1' || item.id === '14010') {
          return true;
        }
        let flag = false;
        flag = `${item.sign || [item.id]}`.split('_').some((i) => {
          return this.permissionList.indexOf(window.parseInt(i)) >= 0;
        });
        return flag;
      },
      checkBodyWidth () {
        let _this = this;
        window.onresize = function () {
          _this.bodyWidth = document.body.clientWidth;
          _this.opened = _this.bodyWidth < 1280 ? [] : _this.opened;
        };
      },
      jump (child, menu) {
        let path = child.path;
        if (this.$route.path === path || this.$route.path === path + '/') {
          // 转到中间件来强制刷新当前 router-view
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: path
            }
          });
        } else {
          this.navigateTo({
            path: path
          });
          _hmt.push(['_trackEvent', 'click_subMenu', child.name, menu.name]);
        }
      }
    },
  };
</script>

<style lang="less">
  nav {
    width: 200px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    .el-menu {
      border-right: 0 none;
    }
  }
</style>



// WEBPACK FOOTER //
// SideNav.vue?2e9a964b